// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RHPWrapper__RHPLoader___2Dm8_{background:var(--dc-global-color-background);min-width:51px}", ""]);
// Exports
exports.locals = {
	"RHPLoader": "RHPWrapper__RHPLoader___2Dm8_"
};
module.exports = exports;
